import SelectAbstract from "components/SelectAbstract";
import ButtonIcon from "components/ButtonIcon";
import Button from "components/Button";
import Input from "components/Input";

import './themes/default.less';
import './index.less';

export default class addNewItems extends SelectAbstract {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        };
    }

    show() {
        super.show();
    }

    add() {
        this.toggleOpenedState();
        const count = this.inputNewPos.value;
        globalThis.appPageView.openDialog("newPosition", { count, ...this.props });
    }

    renderSelector() {
        return (
            <div ref={el => this.selector = el} className="selectorDate flex centerV hand" onClick={this.toggleOpenedState.bind(this)}>
                <ButtonIcon name="plus" />
            </div>

        );
    }

    renderPopup() {
        return (
            <div ref={el => this.popup = el} className="selectPopup flex centerH pos abs">
                <div className="addNewItems flex col gap8">
                    <div className="title text p2">{this.tr("price.countNewPositions")}</div>
                    <div className="flex gap8">
                        <Input
                            ref={el => this.inputNewPos = el}
                            type="number"
                            value="1"
                            inputProps={{
                                min: 1,
                                max: 100,
                                step: 1,
                            }}
                            onChange={null}
                        />
                        <Button
                            label="price.add"
                            size="small"
                            onClick={this.add.bind(this)}
                        />
                    </div>

                </div>
            </div>
        );
    }
}
